<template>
  <vx-card :class="$route.path === '/settings' ? '' : 'container mt-5'">
    <template v-if="skeleton">
        <div class="flex flex-col md:flex-row p-4">
          <a-skeleton class="mx-2 p-4" v-for="n in 4" :paragraph="{ rows: 6 }" active
                      style="box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"/>
        </div>
      </template>
    <a-spin v-else :spinning="loading" :indicator="indicator">
        <div class="flex items-center space-x-2 pb-5">
          <div>npm run serveEnter your Team Size:</div>
          <a-input-number v-model="userCount" :min="1" @change="handlePlanPrice"/>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8 m-4 cursor-pointer">
          <div v-for="(plan,ind) in plans" :key="ind">
            <div class="border-r p-10 relative flex flex-col items-center plan-hover"
                 style="box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;">
              <h4 class="text-xl font-bold mb-8 title-price">{{ plan.title }}</h4>
              <h6 class="text-xs title-price">Original price</h6>
              <div class="mb-5">
                <span class="text-md price-original">RM</span>
                <span class="text-4xl line-through">{{ plan.price }}</span>
                <span class="text-sm">user/month</span>
              </div>
              <h6 class="text-xs title-price">Early bird's price</h6>
              <div>
                <span class="text-md price-original">RM</span>
                <span class="text-5xl">{{ plan.discounted_price }}</span>
                <span class="text-sm">user/month</span>
              </div>
              <a-button type="primary" @click="handlePaymentAccount(plan)" class="absolute px-4" style="bottom: -1rem;border-radius: 3px !important;">Buy Plan
              </a-button>
            </div>
          </div>
        </div>
      </a-spin>
    <a-modal title="Detail Plan" :visible="visibleDetailPlan" @cancel="visibleDetailPlan = false">
      <template v-if="detailPlan">
        <a-descriptions v-if="detailPlan.message === undefined" :column="2">
          <a-descriptions-item label="User Name">{{ detailPlan.user_name }}</a-descriptions-item>
          <a-descriptions-item label="User Email">{{ detailPlan.user_email }}</a-descriptions-item>
          <a-descriptions-item label="Amount">{{ detailPlan.amount }}</a-descriptions-item>
          <a-descriptions-item label="Currency">{{ detailPlan.currency }}</a-descriptions-item>
          <a-descriptions-item label="Plan">{{ detailPlan.title }}</a-descriptions-item>
          <a-descriptions-item label="Number of user">{{ userCount }}</a-descriptions-item>
        </a-descriptions>
        <template v-else>
          <a-alert :message="detailPlan.message" type="error" banner></a-alert>
          <a-button type="primary" @click="visibleDetailPlan = false" class="mt-5">Ok</a-button>
        </template>
        <form method="post" name="ePayment" action="https://payment.ipay88.com.my/ePayment/entry.asp">
          <input type="hidden" name="MerchantCode" :value="detailPlan.merchant_code"/>
          <input type="hidden" name="RefNo" :value="detailPlan.ref_no"/>
          <input type="hidden" name="Amount" :value="detailPlan.amount"/>
          <input type="hidden" name="Currency" :value="detailPlan.currency"/>
          <input type="hidden" name="ProdDesc" :value="detailPlan.prod_desc"/>
          <input type="hidden" name="UserName" :value="detailPlan.user_name"/>
          <input type="hidden" name="UserEmail" :value="detailPlan.user_email"/>
          <input type="hidden" name="SignatureType" :value="detailPlan.signature_type"/>
          <input type="hidden" name="Signature" :value="detailPlan.signature"/>
          <input type="hidden" name="ResponseURL" :value="detailPlan.response_url"/>
          <input type="hidden" name="BackendURL" :value="detailPlan.backend_url"/>
          <input
            v-if="detailPlan.message === undefined"
            type="submit"
            name="Submit"
            value="Proceed with Payment"
            class="rounded mt-5"
          />
        </form>
      </template>
    </a-modal>
  </vx-card>
</template>

<script>
import axios from '@/axios'
import mixin from '../../../mixin/mixin'

export default {
  name: "Plans",
  mixins: [mixin],
  data() {
    return {
      plans: [],
      detailPlan: null,
      visibleDetailPlan: false,
      loading: false,
      skeleton: false,
      userCount: 1,
    }
  },
  methods: {
    async fetch() {
      try {
        this.skeleton = true
        const {data} = await axios.post('subscription/plans')
        this.plans = data.rows.reverse()
        await this.handlePlanPrice()
      } catch (e) {
        throw new Error(e)
      } finally {
        this.skeleton = false
      }
    },
    async handlePaymentAccount(item) {
      try {
        this.loading = true
        const _id = this.$route.query.plan_id ? this.$route.query.plan_id : item.id
        const {data} = await axios.post('subscription/plan-transaction', {plan_id: _id, user_count: this.userCount})
        this.visibleDetailPlan = true
        this.detailPlan = { ...data,...item }
      } catch (e) {
        this.visibleDetailPlan = false
        throw new Error(e)
      } finally {
        this.loading = false
      }
    },
    handlePlanPrice() {
      const value = this.userCount
      this.plans.map(item => {
        const sortRules = item.rules.sort((a,b) => b.value - a.value)
        for (let i = 0; i < sortRules.length; i++) {
          if (value >= sortRules[i].value) {
            item.price = sortRules[i].price
            item.discounted_price = sortRules[i].discounted_price
            break;
          }
        }
      })
    }
  },
  async mounted() {
    console.log(this.$route,'this.$route')
    await this.fetch()
    if (this.$route.query.plan_id)
     await this.handlePaymentAccount()
  }
}
</script>

<style>
input[type="submit"] {
  border: none;
  outline: none;
  background-color: #3a3dbe;
  color: white;
  font-size: 0.938rem;
  font-weight: 500;
  border-radius: 0.375rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.text-primary {
  color: #3A3DBE
}

.price-original {
  vertical-align: top;
  line-height: 3rem;
}

.plan-hover {
  transition: all 0.5s ease;
}

.plan-hover:hover {
  transition: all 0.5s ease;
  background-color: #3A3DBE !important;
  transform: translateY(-20px);
  border-radius: 5px;
}

.plan-hover:hover div {
  color: white;
}

.plan-hover .title-price {
  color: gray;
}

.plan-hover:hover .title-price {
  color: white;
}
</style>
